module.exports = __webpack_public_path__ + "static/media/ladder-truck.46fb512d.svg";